import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const firstName = (() => {
    const name = (user as any)?.name || (user?.email ? user.email.split('@')[0] : 'Usuário');
    return String(name).split(' ')[0];
  })();

  const menuItems = [
    { path: '/dashboard', icon: 'ri-dashboard-line', label: 'Dashboard' },
    { path: '/gerar-apostas', icon: 'ri-magic-line', label: 'Gerar Apostas' },
    { path: '/meus-jogos', icon: 'ri-ticket-line', label: 'Meus Jogos' },
    { path: '/resultados', icon: 'ri-bar-chart-line', label: 'Resultados' },
    { path: '/estatisticas', icon: 'ri-bar-chart-2-line', label: 'Estatísticas' },
    { path: '/notificacoes', icon: 'ri-notification-3-line', label: 'Notificações' }
  ];

  return (
    <aside className="hidden md:flex fixed left-0 top-0 bottom-0 w-72 bg-gradient-to-b from-slate-900/95 to-slate-950/95 backdrop-blur-xl border-r border-white/10 p-6 flex-col">
      {/* Logo */}
      <Link to="/dashboard" className="flex items-center gap-3 mb-12 cursor-pointer group">
        <img src="/logo-clover.png" alt="Premiei" className="h-10 w-10 group-hover:scale-110 transition-transform" />
        <span className="text-2xl font-bold bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent">Premiei</span>
      </Link>

      {/* Menu */}
      <nav className="flex-1 space-y-2">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all cursor-pointer group ${
                isActive
                  ? 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 text-white shadow-lg shadow-cyan-500/10'
                  : 'text-white/60 hover:text-white hover:bg-white/5'
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg transition-all ${
                isActive ? 'bg-gradient-to-br from-cyan-500 to-blue-600' : 'bg-white/5 group-hover:bg-white/10'
              }`}>
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              <span className="font-medium text-sm">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* Sair */}
      <div className="pt-6 border-t border-white/10">
        <button
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-500 hover:to-pink-500 transition-all cursor-pointer"
          onClick={() => { logout(); navigate('/'); }}
        >
          <i className="ri-logout-box-line text-lg"></i>
          <span className="font-semibold">Sair</span>
        </button>
      </div>
    </aside>
  );
}
